import { c as _c } from "react/compiler-runtime";
import { useCursorPagination } from '@/hooks/useCursorPagination';
import { orpc } from '@/lib/orpc/client';
import { errorCodeOf } from '@/lib/orpc/errors';
import { type AllocationTransactionsQueryInput, allocationTransactionsQueryKey, NO_TRANSACTIONS, toCursorPage } from '../allocationTransactionsQuery';
export const useAllocationTransactionsData = input => {
  const $ = _c(8);
  let t0;
  if ($[0] !== input) {
    t0 = allocationTransactionsQueryKey(input);
    $[0] = input;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== input) {
    t1 = async cursor => {
      ;
      try {
        return toCursorPage(await orpc.vaultV2.allocationTransactions.call({
          ...input,
          cursor
        }));
      } catch (t2) {
        const error = t2;
        if (cursor === undefined && errorCodeOf(error) === "NOT_FOUND") {
          return toCursorPage(NO_TRANSACTIONS);
        }
        throw error;
      }
    };
    $[2] = input;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `${input.chainId}:${input.address}:${input.limit}`;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      resetKey: t2,
      trustCursorOnEmptyPage: true
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useCursorPagination(t3);
};